export interface Page<T> {
    content: T[]
    totalElements: number
    totalPages: number
    number: number
    size: number
}

/* eslint-disable i18next/no-literal-string -- field name constants for backend API */
export const PageRequestFields = {
    page: 'page',
    size: 'size',
    sort: 'sort',
} as const
/* eslint-enable i18next/no-literal-string */
